<template>
    <div style="width: 100%; height: 100%; box-sizing: border-box">
        <div v-for="(table, ti) of addressTable" :key="ti">
            <div class="d-flex" v-for="(row, ri) of table.rows" :key="ri">
                <div
                    class="d-flex align-center"
                    v-for="(col, ci) of row.columns"
                    :key="ri + '-' + ci"
                    :style="getStyle(col)"
                >
                    <template v-if="col.title">
                        {{ col.title }}
                    </template>
                    <template v-else-if="col.key && isLoaded">
                        <v-row no-gutters class="pt-2">
                            <v-col cols="12" v-if="!fieldsChild[colKey + col.key]">
                                {{ colKey + col.key }}
                                <v-progress-circular indeterminate color="primary" size="20" />
                            </v-col>
                            <!-- selector -->
                            <v-col cols="12" v-else-if="isSelector(col.key)">
                                <v-select-filled
                                    :disabled="isSent || readOnly"
                                    v-model="fieldsChild_[colKey + col.key].value"
                                    :items="getSelectorValuesFile(col.key)"
                                    :label="col.label"
                                    background-color="#FFF"
                                    hide-details
                                    :class="{
                                        'form-field': true,
                                        'focus-form-field': isImpactedByRule(col.key),
                                    }"
                                    clearable
                                    block
                                    @update:model-value="updateSpecManager()"
                                    @click="setFocusedField(col.key)"
                                    density="compact"
                                    item-title="text"
                                    item-value="value"
                                >
                                    <!-- <template v-slot:selection="{ item }">
                                        <v-icon v-if="!item">$fa-caret-down</v-icon>
                                        <span v-if="isSmallInput(col)">
                                            {{ item.value }}
                                        </span>
                                        <span v-else>
                                            {{ item.text }}
                                        </span>
                                    </template> -->
                                </v-select-filled>
                            </v-col>
                            <!-- other -->
                            <v-col cols="12" v-else>
                                <v-text-field-filled
                                    :disabled="isSent || readOnly"
                                    v-model="fieldsChild[colKey + col.key].value"
                                    background-color="#FFF"
                                    dense
                                    :label="col.label"
                                    hide-details
                                    :class="{
                                        'form-field': true,
                                    }"
                                    @update:model-value="updateSpecManager()"
                                    density="compact"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { TaxFormBase } from "./TaxFormBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["updateSpecManager"],
})
export class TaxFormAddress extends TaxFormBase {
    @Prop() component: string;
    @Prop({ default: null }) colKey: string;
    @Prop({ default: null }) subtype: string;

    addressTable_ = null;

    dicoAddressValues = {};

    get type() {
        return this.component.split("address").pop();
    }

    get addressTable() {
        if (!this.addressTable_ && this.component) {
            if (this.component.startsWith("address")) {
                this.addressTable_ = require(`./addressTypes/${this.component}.json`);
            } else if (this.component.startsWith("financial")) {
                this.addressTable_ = require(`./financial/${this.component}.json`);
            } else {
                console.error("unknown component: ", this.component);
                debugger;
            }
        }
        return this.addressTable_.tables;
    }

    updateSpecManager() {
        this.$emit("updateSpecManager");
    }

    getStyle(col) {
        return {
            width: col.width + "%",
            ...col.style,
            // "box-shadow":
            //     `2px 0 0 0 #888,
            //     0 2px 0 0 #888,
            //     2px 2px 0 0 #888,   /* Just to fix the corner */
            //     2px 0 0 0 #888 inset,
            //     0 2px 0 0 #888 inset`,
            padding: "0px 5px",
            "min-height": "20px",
            "justify-content": col?.style?.["text-align"] || "start",
        };
    }

    isSelector(key) {
        const result = !!this.getSelectorValuesFile(key);
        return result;
    }

    getSelectorValuesFile(key) {
        if (!this.component) {
            return null;
        }
        if (!this.dicoAddressValues[this.component]) {
            try {
                if (this.component.startsWith("address")) {
                    this.dicoAddressValues[this.component] = require(
                        `./addressTypes/${this.component}.json`,
                    );
                } else if (this.component.startsWith("financial")) {
                    this.dicoAddressValues[this.component] = require(
                        `./financial/${this.component}.json`,
                    );
                } else {
                    console.error("unknown component: ", this.component);
                }
            } catch (error) {
                console.error(this.component, "not found in dicoAddressValues");
                // debugger
                return [];
            }
        }

        if (this.dicoAddressValues[this.component].tables?.length) {
            for (const table of this.dicoAddressValues[this.component].tables) {
                for (const row of table.rows) {
                    const selectorRow = row.columns.find(
                        (r) => r.key === key && r.type === "selector",
                    );
                    const selector = selectorRow?.selector;
                    if (selector) {
                        let selectorValues = [];
                        if (!this.dicoSelectorValues[selector]) {
                            try {
                                this.millesim;
                                // debugger
                                selectorValues = require(
                                    `./selectors/${this.millesim}/${selector}.json`,
                                ).values;
                            } catch (error) {
                                console.error(selector, "not found in dicoSelectorValues");
                                // debugger
                                return [];
                            }
                        }
                        return [{ text: "", value: "" }, ...selectorValues];
                    }
                }
            }
        }
    }
}

export default toNative(TaxFormAddress);
</script>
